import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "hello" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "lead" }, "Upcoming Events", -1)
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "mb-3"
        }, [
          _createElementVNode("a", {
            href: 'https://tabletop.events'+item.view_uri
          }, _toDisplayString(item.name), 9, _hoisted_3),
          _hoisted_4,
          _createElementVNode("small", null, _toDisplayString(item.geolocation.name) + " on " + _toDisplayString(item.start_date.substr(0,10)), 1)
        ]))
      }), 128))
    ])
  ]))
}